module.exports = __webpack_public_path__ + "img/2024-10-16d_3.31402b5e.jpg";